import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=020e76ff&scoped=true&"
import script from "./CloseIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CloseIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020e76ff",
  null
  
)

export default component.exports